module.exports = __webpack_public_path__ + "static/media/handshake_series2.c34b6f50.webp";